import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";
import {
  addInventoryItemAction,
  getWareHouseListingAction,
  updateInventoryItemAction,
  getInventoryItemStatusListingAction,
  getWareHouseDetailsByIdAction,
  getInventoryStatusListingAction,
  updateInventoryQuantityAction,
  getInventoryStatusBannedItemsListingAction,
  getInventoryStatusDetailsDistributionAction,
} from "./actions/wareHouseActions";

// Define a type for the slice state
interface WareHouseState {
  loader: true | false;
  wareHouseListing: [];
  wareHouseItemDetails: [];
  inventoryItemStatusListing: [];
  currentInventoryItemId: number;
  submitAddForm: number;
  resetAddForm: number;
  wereHouseDistributionData: [];
}
const initialState: WareHouseState = {
  loader: false,
  wareHouseListing: [],
  wareHouseItemDetails: [],
  inventoryItemStatusListing: [],
  submitAddForm: 0,
  resetAddForm: 0,
  currentInventoryItemId: 0,
  wereHouseDistributionData: [],
};

export const wareHouseSlice = createSlice({
  name: "warehouse",
  initialState: initialState,
  reducers: {
    // handle Synchronous Calls
    submitAddForm: (state: WareHouseState) => {
      state.submitAddForm += 1;
    },
    resetAddForm: (state: WareHouseState) => {
      state.resetAddForm += 1;
    },
    setCurrentItemId: (state: WareHouseState, action: any) => {
      state.currentInventoryItemId = action.payload;
    },
  },
  extraReducers: (builder) => {
    //  getInventoryStatusDetailsDistributionAction methods
    builder.addCase(getInventoryStatusDetailsDistributionAction.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getInventoryStatusDetailsDistributionAction.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getInventoryStatusDetailsDistributionAction.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.wereHouseDistributionData = payload;
    });
    // handle Asynchronous Calls
    // Get getInventoryStatusListingAction methods
    builder.addCase(getInventoryStatusListingAction.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getInventoryStatusListingAction.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getInventoryStatusListingAction.fulfilled, (state) => {
      state.loader = false;
    });
    // Get getInventoryStatusBannedItemsListingAction methods
    builder.addCase(getInventoryStatusBannedItemsListingAction.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getInventoryStatusBannedItemsListingAction.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getInventoryStatusBannedItemsListingAction.fulfilled, (state) => {
      state.loader = false;
    });
    // handle Asynchronous Calls
    // Get getWareHouseListingAction methods
    builder.addCase(getWareHouseListingAction.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getWareHouseListingAction.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getWareHouseListingAction.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.wareHouseListing = payload;
    });
    // ./getWareHouseListingAction methods
    // Get getInventoryItemStatusListingAction methods
    builder.addCase(getInventoryItemStatusListingAction.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getInventoryItemStatusListingAction.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(getInventoryItemStatusListingAction.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.inventoryItemStatusListing = payload;
    });
    // ./getInventoryItemStatusListingAction methods
    // Get getWareHouseDetailsByIdAction methods
    builder.addCase(getWareHouseDetailsByIdAction.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(getWareHouseDetailsByIdAction.rejected, (state) => {
      state.loader = false;
      state.wareHouseItemDetails = [];
    });
    builder.addCase(getWareHouseDetailsByIdAction.fulfilled, (state, { payload }) => {
      state.loader = false;
      state.wareHouseItemDetails = payload;
    });
    // ./getWareHouseDetailsByIdAction methods
    // Post addInventoryItemAction methods
    builder.addCase(addInventoryItemAction.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(addInventoryItemAction.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(addInventoryItemAction.fulfilled, (state) => {
      state.loader = false;
    });
    // ./Post addInventoryItemAction methods
    // PUT updateInventoryItemAction methods
    builder.addCase(updateInventoryItemAction.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(updateInventoryItemAction.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(updateInventoryItemAction.fulfilled, (state) => {
      state.loader = false;
    });
    // PUT updateInventoryQuantityAction methods
    builder.addCase(updateInventoryQuantityAction.pending, (state) => {
      state.loader = true;
    });
    builder.addCase(updateInventoryQuantityAction.rejected, (state) => {
      state.loader = false;
    });
    builder.addCase(updateInventoryQuantityAction.fulfilled, (state) => {
      state.loader = false;
    });
  },
});

export const { submitAddForm, resetAddForm, setCurrentItemId } = wareHouseSlice.actions; // to Acces Reducers methods

export const loader = (state: RootState) => state.warehouse.loader;
export const selectSubmitAddForm = (state: RootState) => state.warehouse.submitAddForm;
export const selectResetAddForm = (state: RootState) => state.warehouse.resetAddForm;
export const selectWareHouseListing = (state: RootState) => state.warehouse.wareHouseListing;
export const selectWereHouseDistributionData = (state: RootState) =>
  state.warehouse.wereHouseDistributionData;
export const selectWareHouseItemDetails = (state: RootState) =>
  state.warehouse.wareHouseItemDetails;
export const selectInventoryItemStatusListing = (state: RootState) =>
  state.warehouse.inventoryItemStatusListing;
export const selectCurrentInventoryItemId = (state: RootState) =>
  state.warehouse.currentInventoryItemId;
